module.exports = __webpack_public_path__ + "static/media/jasper-21.1bdd0a59.jpg";